module.exports = __webpack_public_path__ + "public/img/yibiaopan_zi_26.744fd404.png";